import * as types from "../actions/ActionTypes";
import BannerType from "@p1s/p1s-common-react/constants/BannerType";
import Banner from "@p1s/p1s-common-react/entities/Banner";

export const getInitialState = () => ({
    maintenanceBanner: undefined,
    announcements: []
});

const bannersReducer = (state = getInitialState(), action) => {
    switch (action.type) {
    case types.GET_BANNERS_SUCCEEDED: {
        const maintenanceBanners = action.banners.filter(b => b.bannerType === BannerType.maintenance);
        let maintenanceBanner;
        if (maintenanceBanners.length > 0)
            maintenanceBanner = maintenanceBanners[0];
        const announcements = action.banners.filter(b => b.bannerType === BannerType.announcement);
        return { ...state, maintenanceBanner: maintenanceBanner, announcements: announcements };
    }
    default:
        return state;
    }
};

export default bannersReducer;
